// Police App Integration Configuration
export const POLICEAPP_CONFIG = {
    PUBLIC_KEY: 'POLICEAPP',
    //VALIDATE_URL: 'https://cop-main.patterneffects.in'
    //VALIDATE_URL: 'http://52.66.40.36/muddemal/'
    VALIDATE_URL: 'https://muddemal.hassan.patterneffects.in'
};
// export const POLICEAPP_CONFIG = {
//     PUBLIC_KEY:  'POLICEAPP',
//     VALIDATE_URL:  'http://localhost:5000'
// };

// Debug logging for production
if (process.env.NODE_ENV === 'production') {
    console.log('Police App Config:', POLICEAPP_CONFIG);
    console.log('Validation URL:', `${POLICEAPP_CONFIG.VALIDATE_URL}/api/sso/validate-token-id`);
}

// Helper function to get the full validation URL
export const getValidationUrl = () => {
    return `${POLICEAPP_CONFIG.VALIDATE_URL}/api/sso/validate-token-id`;
};
